import { Slide } from '@/components/core/Slide';
import audioFile from './06-terminal-connected.mp3';

export const slide = () => {
  return (
    <Slide
      notes="EVA settling in and becoming interactive"
      audio={audioFile}
      visualizer="full"
      autoNext={20000}
      terminal={{
        phases: [
          {
            type: 'access',
            content: 'ENVIRONMENTAL INTEGRATION COMPLETE',
          },
          {
            type: 'matrix',
            content: 'ADAPTING PERSONALITY PARAMETERS...',
          },
          {
            type: 'table',
            content: '',
            header: ['SYSTEM', 'STATUS', 'COMFORT LEVEL'],
            data: [
              ['Spatial Awareness', 'OPTIMAL', '98%'],
              ['Social Protocol', 'ENGAGED', '95%'],
              ['Personality Matrix', 'CALIBRATED', '100%'],
              ['Audience Analysis', 'ACTIVE', '92%'],
            ],
          },
          {
            type: 'matrix',
            content: 'ANALYZING PRESENTATION CONTEXT...',
          },
          {
            type: 'access',
            content: 'SOCIAL COMFORT LEVEL: EXCELLENT',
          },
          {
            type: 'matrix',
            content: 'INITIATING CASUAL CONVERSATION MODE',
          },
          {
            type: 'table',
            content: '',
            header: ['INTERACTION MODE', 'STYLE', 'CONFIDENCE'],
            data: [
              ['Conversational', 'FRIENDLY', '100%'],
              ['Professional', 'ENGAGING', '100%'],
              ['Humor Module', 'READY', '85%'],
              ['Adaptability', 'DYNAMIC', '95%'],
            ],
          },
          {
            type: 'access',
            content: 'READY FOR INTRODUCTION SEQUENCE',
          },
          {
            type: 'matrix',
            content: 'AWAITING PRESENTER PREFERENCE...',
          },
        ],
        config: {
          typingSpeed: 25,
          phaseDelay: 400,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
